<template>
  <div v-if="data" class="bill-to">
    <div class="attention">
      <span class="label">{{ attentionOrContactName }}</span>
      <span v-if="showRemove" class="action" @click="$emit('remove')">
        <font-awesome-icon icon="minus-circle"></font-awesome-icon>
      </span>
    </div>
    <div v-if="data.type === 'PAPER_MAIL'">
      <address-display :address="addressFields" />
    </div>
    <div v-else-if="data.type === 'EMAIL'">
      <font-awesome-icon icon="email"></font-awesome-icon>
      {{ billingEmail }}
    </div>
    <div v-else-if="data.type === 'OTHER'">
      {{ data.other || 'Unknown' }}
    </div>
    <div v-else class="error">
      {{ data.id }}
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import AddressDisplay from '../components/AddressDisplay';
export default {
  name: 'BillingMethodDisplay',
  components: {
    AddressDisplay
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    showRemove: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    attentionOrContactName() {
      const val = this.data.attention ? this.data.attention : this.data.client_contact || '';

      return val;
    },
    addressFields() {
      const {
        address_line1,
        address_line2,
        city,
        postal_code,
        province_abbr,
        // eslint-disable-next-line no-unused-vars
        ...otherFields
      } = this.data;

      return {
        address_line1,
        address_line2,
        city,
        postal_code,
        province_abbr
      };
    },
    billingEmail() {
      const val = this.data.email ? this.data.email : this.data.client_contact_email || 'Unknown';
      return val;
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.bill-to {
  display: flex;
  flex-direction: column;
  .label {
    font-weight: bold;
  }
  .attention {
    display: flex;

    .action {
      position: relative;
      flex-basis: 30px;
      height: 30px;
      color: $row-border;
      margin-left: auto;
      svg {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      &:hover {
        cursor: pointer;
        background-color: $row-border;
        border-radius: 100%;
        color: $white;
      }
    }
  }
}
</style>
